import { render, staticRenderFns } from "./sales-slip-print.vue?vue&type=template&id=74cca8b2&"
import script from "./sales-slip-print.vue?vue&type=script&lang=js&"
export * from "./sales-slip-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports